// import * as icons from "@material-ui/icons";
import { Button, Paper } from '@material-ui/core';
import moment from 'moment';
import * as React from 'react';
import { connect } from 'react-redux';
import { Action, Dispatch } from 'redux';
import { IJob } from 'src/store/types/job';
import { Table, TableBody, TableCell, TableHead, TableRow } from '../../../components/Table';
import { removeReviewRequest } from '../../../store/actions/reviews';
import { fetchUserDetailRequest } from '../../../store/actions/users';
import { IReview } from '../../../store/types/review';
import { IUser, IUsersState } from '../../../store/types/user';

class UserDetail extends React.Component<any, any> {
  public componentDidMount() {
    this.props.fetchUser(this.props.match.params.userId);
  }

  public removeReview(id: number) {
    return () => {
      this.props.removeReview(id, this.props.fetchUser(this.props.match.params.userId));
    };
  }

  public render() {
    const user = this.props.user as IUser;

    if (!user) {
      return <p>No data!</p>;
    }

    return (
      <>
        <Paper className="UserDetail">
          {user.id}: {`${user.given_name} ${user.family_name}`}<br />
          {user.phone}<br />
          {user.email}
          <h2>Reviews</h2>
          {user.reviews ? this.renderReviews(user.reviews) : null}
          <br />
          <h2>Jobs</h2>
          {user.jobs ? this.renderJobs(user.jobs) : null}
        </Paper>
      </>
    );
  }

  public renderReviews(reviews: IReview[]) {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell numeric={true}>ID</TableCell>
            <TableCell numeric={true}>Rating</TableCell>
            <TableCell>Review</TableCell>
            <TableCell>Author</TableCell>
            <TableCell numeric={true}>Job</TableCell>
            <TableCell>Created</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reviews.map(r => {
            return (
              <TableRow key={r.id} hover={true}>
                <TableCell numeric={true}>{r.id}</TableCell>
                <TableCell numeric={true}>{r.rating}</TableCell>
                <TableCell>{r.message}</TableCell>
                <TableCell>
                  {r.author ? `${r.author.given_name} ${r.author.family_name}` : r.author_id}
                </TableCell>
                <TableCell numeric={true}>{r.job_id}</TableCell>
                <TableCell>{new Date(r.created_at).toLocaleString('cs-CZ')}</TableCell>
                <TableCell>
                  <Button variant="contained" onClick={this.removeReview(r.id)}>
                    Remove
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  }

  public renderJobs(jobs: IJob[]) {
    return (
      <Table>
        <TableHead>
          <TableRow>
              <TableCell numeric={true}>ID</TableCell>
              <TableCell>Created</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Gender</TableCell>
              <TableCell>Starts</TableCell>
              <TableCell>Ends</TableCell>
              <TableCell>Address</TableCell>
              <TableCell>Platform</TableCell>
              <TableCell>Salary</TableCell>
              <TableCell numeric={true}>#reactions</TableCell>
              <TableCell numeric={true}>#positive reactions</TableCell>
              <TableCell numeric={true}>#calls</TableCell>
              <TableCell numeric={true}>#accepted</TableCell>
              <TableCell>Days to Expire</TableCell>
              <TableCell>Term</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
          {jobs.map(r => {
            return (
              <TableRow key={r.id} hover={true}>
                <TableCell numeric={true}>{r.id}</TableCell>
                      <TableCell>
                        {new Date(r.created_at).toLocaleString("cs-CZ")}
                      </TableCell>
                      <TableCell>{r.description}</TableCell>
                      <TableCell>{r.gender}</TableCell>
                      <TableCell>{r.starts_at}</TableCell>
                      <TableCell>{r.ends_at}</TableCell>
                      <TableCell>
                        {r.place ? r.place.address : r.place_id}
                      </TableCell>
                      <TableCell>{r.platform}</TableCell>
                      <TableCell>
                        {r.salary}/{r.salary_type}
                      </TableCell>
                      <TableCell numeric={true}>
                        {r.stats ? r.stats.total : 0}
                      </TableCell>
                      <TableCell numeric={true}>
                        {r.stats
                          ? r.stats.applied +
                            r.stats.accepted +
                            r.stats.rejected
                          : 0}
                      </TableCell>
                      <TableCell numeric={true}>
                        {r.stats ? r.stats.calls : 0}
                      </TableCell>
                      <TableCell numeric={true}>
                        {r.stats ? r.stats.accepted : 0}
                      </TableCell>
                      <TableCell>
                        {moment(r.offer_expires_at).fromNow()}
                      </TableCell>
                      <TableCell numeric={true}>{r.term}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  }
}

const mapStateToProps = (state: { users: IUsersState }) => {
  return {
    user: state.users.detail,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    fetchUser: (id: number) => dispatch(fetchUserDetailRequest(id)),
    removeReview: (id: number, onSuccess?: () => Action) =>
      dispatch(removeReviewRequest(id, onSuccess)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDetail);



// WEBPACK FOOTER //
// ./src/screens/Users/UserDetail/UserDetail.tsx